import { render, staticRenderFns } from "./printContent.vue?vue&type=template&id=2b449e26&scoped=true"
import script from "./printContent.vue?vue&type=script&lang=js"
export * from "./printContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b449e26",
  null
  
)

export default component.exports